import {StarRating} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product_reviews.types';
import {GetProductBulkResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {
  useTrackFeature,
  useTrackFeatureInViewImpression,
} from '@aboutyou/tracking';
import {COLORS} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled from 'styled-components';
import {useProductReviewSectionScrollManager} from '../../ProductInformationBox/tabs/useProductReviewSectionScrollManager';
import {OverallRating, OverallStarsContainer} from '../Sections/OverallRating';
import {useProductDetailsReviewsABTest} from '../utils/useReviewsABTest';

export const PriceAndBrandReviewsSectionView: FC<
  GetProductBulkResponse['reviewSection']
> = ({summary}) => {
  const {showReviewsOnPriceAndBrand} = useProductDetailsReviewsABTest(
    Boolean(summary),
  );

  if (!showReviewsOnPriceAndBrand || !summary) {
    return null;
  }

  const {overallRating, overallStarRating, reviewCount} = summary;

  return (
    <TrackedOverallRating
      overallStarRating={overallStarRating}
      overallRating={overallRating}
      reviewCount={reviewCount}
    />
  );
};

const TrackedOverallRating: FC<{
  overallStarRating: StarRating;
  overallRating: number;
  reviewCount: number;
}> = ({overallStarRating, overallRating, reviewCount}) => {
  const featureTrackingLabel = 'review|adp|summary|';

  const {ref} = useTrackFeatureInViewImpression<HTMLDivElement>({
    label: `${featureTrackingLabel}${overallRating}|${reviewCount}`,
  });
  const trackFeature = useTrackFeature();
  const {scrollToReviewsSection} = useProductReviewSectionScrollManager();

  const handleReviewsClick = () => {
    scrollToReviewsSection();
    trackFeature({
      eventType: 'click',
      label: `${featureTrackingLabel}${overallRating}|${reviewCount}`,
    });
  };

  return (
    <StyledOverallRating
      overallStarRating={overallStarRating}
      overallRating={overallRating}
      reviewCount={reviewCount}
      alignment="left"
      disableTitle
      ref={ref}
      onClick={handleReviewsClick}
    />
  );
};

const StyledOverallRating = styled(OverallRating)`
  margin-bottom: 2rem;

  ${OverallStarsContainer} {
    border-bottom: 1px solid transparent;
    transition: border-bottom-color 200ms ease-in;
    cursor: pointer;
    padding-right: 0.3rem;
  }

  &:hover {
    ${OverallStarsContainer} {
      border-bottom-color: ${COLORS.Grey1};
    }
  }
`;
